export default class SingleExecution{
    constructor() {
        this.pendingCallback = null;
        this.execInProgress = false;
        this.currentKey = null;
        this.pendingKey = null;
    }

    async scheduleExecution(key, callback){
        if(this.currentKey != null){
            this.pendingCallback = callback;
            this.pendingKey = key;
            return;
        }

        this.currentKey = key;
        try {
            try {
                await callback();
            } catch (e){
                console.error(e);
                throw e;
            }
        } finally {
            this.currentKey = null;
        }
        if(!this.pendingKey){
            return;
        }

        let newKey = this.pendingKey;
        let newPendingCallback = this.pendingCallback;
        this.pendingCallback = null;
        this.pendingKey = null;
        if(newKey !== key) {
            await this.scheduleExecution(newKey, newPendingCallback);
        }
    }
}